module.exports = __webpack_public_path__ + "static/media/logo.58e25763.png";